export default "__VITE_ASSET__b8c839bc__"